const user = {
    state: {
        status: localStorage.getItem('token') ? 'logined' : 'init',
        data: localStorage.getItem('token') ? { token: localStorage.getItem('token') } : null
    },
    mutations: {
        setLogin(state, data) {
            state.status = 'logined';
            state.data = data;
            return true;
        },
        setLogout(state) {
            state.status = 'logout';
            state.data = null
        },
    }
}

export default user
